import { render, staticRenderFns } from "./board-card.vue?vue&type=template&id=97921d68"
import script from "./board-card.vue?vue&type=script&lang=js"
export * from "./board-card.vue?vue&type=script&lang=js"
import style0 from "./board-card.vue?vue&type=style&index=0&id=97921d68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports